import { IDetailPageData } from "../../../shared/utils/api";

export interface IAdvancedSearchField {
  id: string;
  model_type: string;
  model_id?: string;
  field_name?: string;
  field_id?: string;
  field_type?: string;
  search_term?: string;
  search_term_to?: string;
}

export interface IAdvancedSearchFieldsBackendType {
  advanced_search_fields: IAdvancedSearchField[];
}

export interface ITooltip {
  context: string;
  matched_on: string;
  title: string;
  created_at: string;
  type: string;
}

export interface ISearchResultData {
  id?: string;
  row_id?: string;
  ac_id?: string;
  [key: string]: unknown;
}

export interface ISearchResult {
  data: ISearchResultData;
  match_count: number;
  tooltips: ITooltip[];
}

export interface ISearchResponse {
  execution_time: string;
  results: ISearchResult[];
  total_count: number;
}

export interface ITransformedRow extends ISearchResultData {
  id: string;
  match_count: number;
  tooltips: ITooltip[];
}

export function transformToBackendAdvancedSearchFields(data: IDetailPageData): IAdvancedSearchFieldsBackendType | undefined {
  if (!data.rowData || data.rowData.length === 0) {
    return;
  }
  return {
    advanced_search_fields: data.rowData.map(field => ({
      id: field.id,
      model_type: field.model_type,
      model_id: field.model_id,
      field_name: field.field_name,
      field_id: field.field_id,
      field_type: field.field_type,
      search_term: field.search_term,
      search_term_to: field.search_term_to
    }))
  };
}

export function transformFromBackendAdvancedSearchFields(backendResponse: ISearchResponse): IDetailPageData {
  return {
    rowData: backendResponse.results.map(result => {
      const row = result.data;
      const id = row.sygno_alertcase_id;
      if (!id) {
        throw new Error("Each backend row must have a 'id' property.");
      }
      return { 
        ...row, 
        id,
        match_count: result.match_count,
        tooltips: result.tooltips
      } as ITransformedRow;
    })
  };
}